import { Grid, TextFieldProps, Typography } from '@mui/material'
import { useDescription, useTsController } from '@ts-react/form'
import { DisabledProps, LayoutProps } from '../BillyTsForm'
import { BillyMuiField } from '../../input/JotaiMuiField'

export type StringFieldProps = TextFieldProps &
  LayoutProps &
  DisabledProps & {
    labelAsFieldProp?: boolean
  }

export function StringField({
  layout,
  disabledExplanation,
  hidden,
  onBlur,
  labelAsFieldProp = true,
  ...textFieldProps
}: StringFieldProps) {
  const {
    field: { value, onChange },
    error,
    formState: { isLoading, isSubmitting },
  } = useTsController<string>()
  const { label, placeholder } = useDescription()

  if (hidden) {
    return <></>
  }

  return (
    <Grid container item xs {...layout}>
      {!labelAsFieldProp && label && <Typography sx={{ marginBottom: '0.25rem' }}>{label}</Typography>}
      <BillyMuiField
        isLoading={isLoading || isSubmitting}
        error={error?.errorMessage}
        disabledExplanation={disabledExplanation}
        textFieldProps={{
          value: value ?? '',
          label: labelAsFieldProp ? label : undefined,
          placeholder: placeholder,
          onChange: (event) => onChange(event.target.value),
          onBlur: (event) => {
            onChange(event.target.value.trim())
            onBlur?.(event)
          },
          ...textFieldProps,
        }}
      />
    </Grid>
  )
}
